import { useQuery } from '@tanstack/react-query';
import { useAccessToken } from '../auth/AccessTokenContext';
import { getApiV1ByAnalogueModelIdComputeSettings } from '../api/generated';
import { useParams } from 'react-router-dom';
import { queryKeys } from './queryKeys';

export const useFetchComputeSettings = () => {
  const token = useAccessToken();
  const { modelId } = useParams();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.computeSettings(modelId as string),
    queryFn: () =>
      getApiV1ByAnalogueModelIdComputeSettings({
        path: { analogueModelId: modelId as string },
      }),
    select: (res) => res.data?.data,
    enabled: !!token && !!modelId,
    staleTime: 5 * 60 * 1000,
  });

  return query;
};
